var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolitics({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F2C59D",
    fillRule: "nonzero",
    d: "M4.242 2.945l-.422.38.522.543h-.855l-1.275 1.79h10.576l-1.358-1.79h-.964l.93-.837-.077-.086h.937l2.459 3.239H.285l2.459-3.239z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2C59D",
    d: "M.285 6.184h14.431v1.794H.285z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M7.952.204l2.585 2.87-2.201 1.982H6.085l-1.622-1.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E81A24",
    d: "M7.76 2.923l.153-.007c.845-.04 1.483-.1 1.488.026.005.137-.722.274-1.653.318a5.866 5.866 0 0 1-.317 1.652 19.216 19.216 0 0 1-.019-1.641 5.862 5.862 0 0 1-1.661-.201c.502-.065 1.06-.11 1.672-.134l.005-.227c.018-.828.005-1.45.13-1.446.136.004.222.733.202 1.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2C59D",
    d: "M.644 8.742h13.711v5.717H.644z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolitics);
export default __webpack_public_path__ + "static/media/politics.7011e40f7156d25aec2ae28f62d2528a.svg";
export { ForwardRef as ReactComponent };